import * as React from 'react'
import { useLogout } from '@repo/cf-user/hooks/use-user-data'
import { useTranslations } from 'next-intl'
import { SpinnerIcon } from 'primitives/icons'
import * as Sentry from '@sentry/nextjs'

import { LogoutIcon } from '@web/components/icons/logout'
import { AppRoutes } from '@repo/web-utils/app-routes'
export const LogoutItem = ({ className }: { className: string }) => {
  const [isLoading, setIsLoading] = React.useState(false)
  const logout = useLogout({ loginRoute: AppRoutes.LOGIN })
  const t = useTranslations('pages.my_account.sidebar')

  const handleLogout = async () => {
    setIsLoading(true)
    try {
      await logout()
    } catch (error) {
      Sentry.captureException(error, {
        tags: {
          component: 'my-account-sidebar',
          action: 'logout',
        },
      })
    }
  }

  return (
    <div>
      <p className="text-12 mt-4 py-1 pl-2.5 font-normal ">{t('nav_sections.logout.title')}</p>
      <button onClick={handleLogout} className={className} disabled={isLoading}>
        {isLoading ? (
          <SpinnerIcon className="mr-2 size-4 animate-spin" />
        ) : (
          <LogoutIcon className="mr-2 size-4" />
        )}
        {t('nav_sections.logout.items.logout.title')}
      </button>
    </div>
  )
}
